import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CurrencyIcon from 'components/formatters/currency-icon';

class MoneyField extends Component {
    constructor(props) {
        super(props);

        this.fieldRef = React.createRef();

        if (props.value !== '') {
            this.state = {
                view: this.modelToView(props.value),
                model: props.value,
            };
        } else {
            this.state = {
                view: '',
                model: null,
            }
        }

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        if (this.props.focusOnRender) {
            this.fieldRef.current.focus();
        }
    }

    componentWillReceiveProps(nextProps) {
        // Handle outside value change
        if (this.state.model !== nextProps.value) {
            this.setState({
                view: this.modelToView(nextProps.value),
                model: nextProps.value,
            })
        }
    }

    modelToView(model) {
        if (model === '') {
            return '';
        }

        if (model !== 0) {
            return model / 100;
        }

        return 0;
    }

    viewToModel(value) {
        //console.log(value);
        if (value !== '') {
            return Math.round(value * 100);
        }

        return null;
    }

    handleChange(e) {
        const name = e.target.name;
        const viewValue = e.target.value;
        const modelValue = this.viewToModel(viewValue);

        this.setState({
            view: viewValue,
            model: modelValue,
        }, () => {
            if (this.props.onChange) {
                this.props.onChange({
                    target: {
                        name: name,
                        value: modelValue,
                    }
                })
            }
        });
    }

    render() {
        const { parentClassName, label, className, name, id, required, disabled, placeholder } = this.props;
        const { view } = this.state;

        return (
            <div className={`form-group form-group-default input-group ${parentClassName || ''} ${required ? 'required' : ''}`}>
                <div className="input-group-prepend">
                    <span className="input-group-text">
                        <CurrencyIcon currency="EUR" />
                    </span>
                </div>
                <div className="form-input-group">
                    <label>{label}</label>
                    <input type="number"
                           step={0.01}
                           name={name}
                           id={id}
                           className={`form-control ${className || ''}`}
                           value={view}
                           onChange={this.handleChange}
                           required={required}
                           placeholder={placeholder}
                           readOnly={disabled}
                           ref={this.fieldRef}
                    />
                </div>
            </div>
        );
    }
}



MoneyField.propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    step: PropTypes.string,
    focusOnRender: PropTypes.bool,
};

MoneyField.defaultProps = {
    value: '',
};

export default MoneyField;



// WEBPACK FOOTER //
// ./src/components/form/money-field.js